// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Loaded, Loadable, LoadingStatus, ScopeCategory } from '@app/core';
import { OrganizationsActionsUnion, OrganizationsActionTypes } from './organizations.actions';

export type OrganizationsState = Loaded<ScopeCategory[]> | Loadable;

export function organizationsReducer(
  state: Readonly<OrganizationsState | undefined>,
  action: OrganizationsActionsUnion
): Readonly<OrganizationsState | undefined> {
  switch (action.type) {
    case OrganizationsActionTypes.ORGANIZATION_LOADING:
      return {
        status: LoadingStatus.LOADING
      };

    case OrganizationsActionTypes.ORGANIZATION_LOAD_COMPLETE:
      return {
        status: LoadingStatus.LOAD_COMPLETE
      };

    case OrganizationsActionTypes.ORGANIZATION_LOAD_FAILED:
      return {
        status: LoadingStatus.LOAD_FAILED
      };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/organizations.reducer.ts